import React from "react";
import * as MuiIcons from "@mui/icons-material";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { products } from "../../data/companyData";
import "./SaasSections.css";

function getIcon(name) {
  const Icon = MuiIcons[name] || MuiIcons.Star;
  return <Icon />;
}

export default function ProductCards({ detailed = false }) {
  return (
    <div className={`products-grid ${detailed ? "products-grid--page" : ""}`}>
      {products.map((product) => {
        const isLive = product.status === "live";
        const CardWrapper = isLive && product.url ? "a" : "div";
        const wrapperProps =
          isLive && product.url
            ? {
                href: product.url,
                target: "_blank",
                rel: "noreferrer",
                className: "product-saas-card",
              }
            : {
                className: "product-saas-card product-saas-card--coming-soon",
              };

        const bodyText = detailed ? product.longDescription || product.description : product.description;

        return (
          <CardWrapper key={product.id} {...wrapperProps}>
            {product.status === "coming-soon" && (
              <span className="product-saas-card__ribbon">Coming Soon</span>
            )}
            <div className="product-saas-card__header">
              <div className="product-saas-card__icon">{getIcon(product.icon)}</div>
              <h3 className="product-saas-card__name">{product.name}</h3>
              {isLive && <span className="product-saas-card__badge">Live</span>}
              {/* {product.status === "coming-soon" && (
                <span className="product-saas-card__badge product-saas-card__badge--soon"></span>
              )} */}
            </div>
            <p className={`product-saas-card__desc ${detailed ? "product-saas-card__desc--long" : ""}`}>
              {bodyText}
            </p>
            <div className="product-saas-card__features">
              {product.features.map((feature) => (
                <span key={feature} className="product-saas-card__feature">
                  {feature}
                </span>
              ))}
            </div>
            {isLive && product.url && (
              <span className="product-saas-card__link">
                Launch product <ArrowForwardIcon fontSize="small" />
              </span>
            )}
          </CardWrapper>
        );
      })}
    </div>
  );
}
